import { MenuItem2 } from "@blueprintjs/popover2";
import { ItemRendererProps } from "@blueprintjs/select";
import classNames from "classnames";
import React, { ReactNode } from "react";

import { MultiSelectItem } from "../types";
import { getItemProps } from "../utils";
import styles from "./item.module.scss";

export interface ItemRendererExtendedProps extends ItemRendererProps {
  selected: boolean;
}

export interface ItemRendererComponentProps<TItem extends MultiSelectItem> {
  item: TItem;
  props: ItemRendererExtendedProps;
  itemRenderer?: (item: TItem, props: ItemRendererExtendedProps) => ReactNode;
}

export const Item = <TItem extends MultiSelectItem>({
  item,
  props,
  itemRenderer,
}: ItemRendererComponentProps<TItem>) => {
  // eslint-disable-next-line react/prop-types
  if (!props.modifiers.matchesPredicate) {
    return null;
  }

  return (
    <MenuItem2
      {...getItemProps(item, props)}
      // eslint-disable-next-line react/prop-types
      className={classNames(styles.menuItem, { [styles.selected || ""]: props.selected })}
      key={item.id}
      text={itemRenderer ? itemRenderer(item, props) : item.label}
    />
  );
};
